const stores = [
  {
    name: 'Official Store',
    tagline: 'Merchandise & bundles',
    href: 'https://gracie-and-lilys-adventures.myshopify.com/',
    icon: 'ri-shopping-bag-3-line',
    accent: 'primary',
  },
  {
    name: 'Etsy',
    tagline: 'Handmade & seasonal gifts',
    href: 'https://www.etsy.com/shop/GracieandLilysAdv',
    icon: 'ri-shopping-basket-2-line',
    accent: 'accent',
  },
  {
    name: 'Amazon',
    tagline: 'Journals & print books',
    href: 'https://a.co/d/0gs915Vo',
    icon: 'ri-amazon-fill',
    accent: 'secondary',
  },
  {
    name: 'Gumroad',
    tagline: 'Digital storybooks',
    href: 'https://gladventures.gumroad.com/',
    icon: 'ri-download-2-line',
    accent: 'primary',
  },
];

export default function WhereToBuySection() {
  return (
    <section
      id="where-to-buy"
      aria-labelledby="where-to-buy-heading"
      className="w-full bg-background-100 py-10 md:py-20 relative overflow-hidden scroll-mt-20 border-t border-background-200"
    >
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <div className="w-12 h-12 flex items-center justify-center absolute top-8 left-[6%] opacity-[0.06] rotate-[15deg] animate-float">
          <i className="fa-solid fa-sparkles text-4xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute bottom-10 right-[8%] opacity-[0.05] rotate-[-25deg] animate-drift">
          <i className="fa-solid fa-star text-5xl text-foreground-950"></i>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        <div className="flex items-center justify-center gap-3 mb-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-store-3-line text-xl"></i>
          </span>
          <p className="text-secondary-600 text-xs font-bold uppercase tracking-widest">
            Where to Buy
          </p>
        </div>

        <h2
          id="where-to-buy-heading"
          className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3"
        >
          Find Gracie &amp; Lily Everywhere You Shop
        </h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-12 max-w-3xl mx-auto">
          Pick the shop you already love — every store carries a piece of the magic, from print
          books and journals to digital storybooks and gifts.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {stores.map((store) => (
            <a
              key={store.name}
              href={store.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white border border-background-200 rounded-2xl p-5 flex flex-col gap-3 hover:border-primary-300 hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-xl text-xl ${
                  store.accent === 'accent'
                    ? 'bg-accent-100 text-accent-700'
                    : store.accent === 'secondary'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-600'
                }`}
              >
                <i className={store.icon}></i>
              </span>
              <span className="flex flex-col gap-1">
                <span className="text-base font-extrabold text-foreground-950">{store.name}</span>
                <span className="text-xs text-foreground-600 leading-snug">{store.tagline}</span>
              </span>
              <span className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-primary-600 group-hover:gap-2 transition-all">
                Shop now
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}